import React from 'react'
import SearchResultItemPhoto from './SearchResultItemPhoto';
import SearchResultItemReport from './SearchResultItemReport';
import SearchResultItemTrafficRegulation from './SearchResultItemTrafficRegulation';
import SearchResultItem from './SearchResultItem';

export default function SearchResultSwitch(props) {
    return (
        (() => {
            switch(props.data.type) {
                //写真
                case('photo'): {
                        return (
                            <SearchResultItemPhoto
                                key={props.id}
                                data={props.data} 
                                onEnterItem={props.onEnterItem} 
                                onLeaveItem={props.onLeaveItem} 
                                onEnterImg={props.onEnterImg} 
                                onLeaveImg={props.onLeaveImg} 
                                onTagClick={props.onTagClick}
                                activeItem={props.activeItem}
                                items={props.items}
                                map={props.map}
                                />
                        )
                    }
                //住民通報
                case('report'): {
                    return (
                        <SearchResultItemReport
                            key={props.id}
                            data={props.data} 
                            onEnterItem={props.onEnterItem} 
                            onLeaveItem={props.onLeaveItem} 
                            onEnterImg={props.onEnterImg} 
                            onLeaveImg={props.onLeaveImg} 
                            onTagClick={props.onTagClick}
                            activeItem={props.activeItem}
                            items={props.items}
                            map={props.map}
                        />
                    )
                }
                //通行制限
                case('trafficregulation'): {
                    return (
                        <SearchResultItemTrafficRegulation
                            key={props.id}
                            data={props.data} 
                            onEnterItem={props.onEnterItem} 
                            onLeaveItem={props.onLeaveItem} 
                            onEnterImg={props.onEnterImg} 
                            onLeaveImg={props.onLeaveImg} 
                            onTagClick={props.onTagClick}
                            activeItem={props.activeItem}
                            items={props.items}
                            map={props.map}
                        />
                    )
                }
                //その他
                default: {
                        return (
                            <SearchResultItem
                                key={props.id}
                                data={props.data} 
                                onEnterItem={props.onEnterItem} 
                                onLeaveItem={props.onLeaveItem} 
                                onEnterImg={props.onEnterImg} 
                                onLeaveImg={props.onLeaveImg} 
                                onTagClick={props.onTagClick}
                                activeItem={props.activeItem}
                                items={props.items}
                                map={props.map}
                            />
                        )
                    }
                }
        })()  
    );
}